import { useCallback, useRef } from "react";

const useTilt = (maxTilt = 8) => {
  const ref = useRef(null);

  const handleMove = useCallback(
    (e) => {
      const el = ref.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const midX = rect.width / 2;
      const midY = rect.height / 2;
      const rotY = ((x - midX) / midX) * maxTilt;
      const rotX = ((midY - y) / midY) * maxTilt;
      el.style.transform = `perspective(600px) rotateX(${rotX}deg) rotateY(${rotY}deg) translateY(-4px)`;
      const glare = el.querySelector(".card-glare");
      if (glare) {
        const pctX = (x / rect.width) * 100;
        const pctY = (y / rect.height) * 100;
        glare.style.background = `radial-gradient(circle at ${pctX}% ${pctY}%, rgba(255,255,255,0.08) 0%, transparent 60%)`;
        glare.style.opacity = "1";
      }
    },
    [maxTilt]
  );

  const handleLeave = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.style.transform = "";
    const glare = el.querySelector(".card-glare");
    if (glare) glare.style.opacity = "0";
  }, []);

  return { ref, handleMove, handleLeave };
};

export default useTilt;
